'use client';

import ProductCard from '@repo/ui/src/components/ContentGrid/ProductCard';
import useProducts from '@hooks/product/useProducts';
import { useVipAccess } from '@hooks/customer';

import type { ProductModelProps } from '@typings/product';
import type { BackgroundStyle } from '@repo/ui/src/components/ContentGrid';

interface ProductGridProps {
  items: Array<ProductModelProps>;
  backgroundStyle?: BackgroundStyle;
  itemsPerRow?: number;
}

const ProductGrid = ({ items, backgroundStyle, itemsPerRow }: ProductGridProps) => {
  const { products, isLoading } = useProducts(items);
  const { vip } = useVipAccess();

  if (isLoading) {
    return (
      <>
        {Array.from({ length: items.length || 3 }, (_, i) => (
          <li key={i} className="h-full">
            <div className="relative h-full flex flex-col border-r border-b border-neutral-200 pt-8 sm:pt-10 p-4 sm:p-8 md:p-10 animate-pulse">
              <div className="w-full aspect-square bg-neutral-200 rounded mb-4" />
              <div className="flex flex-col gap-2">
                <div className="h-4 w-1/3 bg-neutral-200 rounded" />
                <div className="h-5 w-2/3 bg-neutral-200 rounded" />
                <div className="h-5 w-1/4 bg-neutral-200 rounded" />
              </div>
            </div>
          </li>
        ))}
      </>
    );
  }

  if (!products || products.length === 0) return null;

  return (
    <>
      {products.map((product: any, index: number) => (
        <li key={product.sku || index} className="h-full">
          <ProductCard
            product={product}
            backgroundStyle={backgroundStyle}
            vip={vip}
            itemsPerRow={itemsPerRow}
          />
        </li>
      ))}
    </>
  );
};

export default ProductGrid;
